/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_Event_NameInputs */

const cs_sklik_event_name = /** @type {(inputs: Sklik_Event_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název konverzní události`)
};

const en_sklik_event_name = /** @type {(inputs: Sklik_Event_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversion event name`)
};

/**
* | output |
* | --- |
* | "Conversion event name" |
*
* @param {Sklik_Event_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_event_name = /** @type {((inputs?: Sklik_Event_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Event_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_event_name(inputs)
	return cs_sklik_event_name(inputs)
});